import React from 'react';
import { Text, Link } from 'components/ui';
import uiUtils from 'utils/UI';
import languageLocale from 'utils/LanguageLocale';
import { wrapFunctionalComponent } from 'utils/framework';
import CallToActionEN from 'components/ProductPage/CallToAction/locales/CallToAction_en_US';
import CallToActionFR from 'components/ProductPage/CallToAction/locales/CallToAction_fr_CA';

const getText = languageLocale.getLocalisedDataFromResource(CallToActionEN, CallToActionFR);

const DownloadText = () => (
    <>
        <Link
            color='blue'
            underline={true}
            padding={2}
            margin={-2}
            href='/beauty/mobile'
            children={getText('download')}
        />{' '}
        {getText('or')}{' '}
        <Link
            display={[null, null, 'none']}
            color='blue'
            underline={true}
            padding={2}
            margin={-2}
            href={uiUtils.getAppLink()}
            children={getText('openApp')}
        />
        <Text
            display={['none', null, 'inline']}
            children={getText('openApp')}
        />
    </>
);

export default wrapFunctionalComponent(DownloadText, 'DownloadText');
